export enum Role {
  ADMIN = 'admin',
  USER = 'user',
  CUSTOMER_USER = 'customeruser',
  CUSTOMER_ADMIN = 'customeradmin'
}



// WEBPACK FOOTER //
// ./src/app/enums/role.enum.ts